<template>
  <div class="title-bar clearfix">
    <div slot="header" class="clearfix">
      <div class="module pull-left">
        {{ $t("CMUserView") }}
      </div>

      <div class="btn-group pull-right">

        <el-button plain size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button plain size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>

      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">

      <el-table class="customer-table" border stripe :data="CMUserData" size="mini">
        <el-table-column prop="ChannelAccount" :label="this.$t('ChannelAccount')" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="ChannelName" :label="this.$t('BICustomName')" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="UserType" :label="this.$t('ChannelType')" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="Office" :label="this.$t('Office')" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="SaleAreas" :label="this.$t('ReceivedSalsArea')" header-align="center" align="center">
        </el-table-column>
      </el-table>
    </div>

    <el-row style="margin-top:10px;">
      <el-pagination style="float:right" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>

    <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" width="45%">

      <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="100px">
        <el-form-item :label="this.$t('BICustomName')" size="small">
          <el-input v-model="filter.ChannelName" class="localinputwidth" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('ChannelAccount')" size="small">
          <el-input v-model="filter.ChannelAccount" class="localinputwidth" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('Office')" size="small">
          <el-input v-model="filter.Office" auto-complete="off" class="localinputwidth"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('SalesArea')" size="small">
          <el-select v-model="filter.SalesAreas" multiple size="small" class="localinputwidth">
            <el-option v-for="t in salesAreasList" :key="t.Code" :label="t.Code" :value="t.Code"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="this.$t('UserType')" size="small" class="usertype-selector">
          <el-select v-model="filter.ChannelType" multiple size="small">
            <el-option v-for="t in userTypeList" :key="t" :label="$t('UserType'+t)" :value="t"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="searchDialogVisible = false" plain size="mini">{{this.$t('cancel')}}</el-button>
        <el-button @click="resetFilter" :plain="true" size="mini">{{$t('reset')}}</el-button>
        <el-button type="primary" @click="search" plain size="mini">{{this.$t('confirm')}}</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import OperationHeader from "@/components/shared/OperationHeader";
import qs from "qs";
import _ from "lodash";
import ATips from "@/components/shared/ATips";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";

export default {
  name: "CMUser",
  components: { OperationHeader, ATips },
  data() {
    return {
      loading: true,
      filter: {
        ChannelAccount: "",
        ChannelName: "",
        ChannelType: [],
        SalesAreas: [],
        Office: ""
      },
      salesAreasList: [],
      userTypeList: [],
      searchDialogLabelWidth: "120px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      CMUserData: [],
      filterOptions: []
    };
  },
  created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
    this.setup();
  },
  methods: {
    setup() {
      this.userTypeSetup();
      this.salesAreaSetUp();
    },
    resetFilter() {
      this.filter = {
        ChannelAccount: "",
        ChannelName: "",
        ChannelType: [],
        SalesAreas: [],
        Email: "",
        Name: "",
        Bu: "",
        Office: ""
      };
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },

    obtainTableDataAccordingToConditions() {
      this.loading = true;
      this.$axios
        .get("api/cmuser/getuser", {
          params: {
            filter: this.filtergenerator(),

            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        })
        .then(response => {
          this.translateData(response.data.Data);
          this.totalCount = response.data.TotalCount;
          this.loading = false;
        });
    },

    refresh() {
      this.pageIndex = 1;
      this.clearFilter();
      this.obtainTableDataAccordingToConditions();
    },

    userTypeSetup() {
      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
        this.userTypeList.push(9);
      }
    },
    salesAreaSetUp() {
      this.$axios.get("api/cmuser/cmsalesarea").then(response => {
        this.salesAreasList = response.data;
      });
    },
    clearFilter() {
      this.filter.ChannelName = "";
      this.filter.SalesAreas = [];
      this.filter.Office = "";
      this.filter.ChannelType = [];
      this.filter.ChannelAccount = "";
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.CUSTOERMER_HISTORY);
    },
    translateData(data) {
      for (var i = 0; i < data.length; i++) {
        var utype = "UserType" + data[i].UserType;
        data[i].UserType = this.$t(utype);
      }
      this.CMUserData = data;
      this.loading = false;
    },
    search() {
      this.pageIndex = 1;
      this.searchDialogVisible = false;
      this.obtainTableDataAccordingToConditions();
    },
    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.CUSTOERMER_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    search() {
      this.searchDialogVisible = false;
      this.pageIndex = 1;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.CUSTOERMER_HISTORY,
        this.filterOptions
      );
      this.obtainTableDataAccordingToConditions();
    },
    filtergenerator() {
      var filterOptions = [];

      if (
        this.filter.ChannelName !== null &&
        this.filter.ChannelName.trim() !== ""
      ) {
        var filterOption = {
          name: "ChannelName",
          value: this.filter.ChannelName
        };

        filterOptions.push(filterOption);
      }

      if (
        this.filter.ChannelAccount !== null &&
        this.filter.ChannelAccount.trim() !== ""
      ) {
        var filterOption = {
          name: "ChannelAccount",
          value: this.filter.ChannelAccount
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.Office !== null && this.filter.Office.trim() !== "") {
        var filterOption = {
          name: "Office",
          value: this.filter.Office
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.SalesAreas.length > 0) {
        var selectedSalesArea = "";
        var count = 0;

        for (var i = 0; i < this.filter.SalesAreas.length; i++) {
          selectedSalesArea += this.filter.SalesAreas[i];
          if (count !== this.filter.SalesAreas.length - 1) {
            selectedSalesArea += "%";
          }
          count++;
        }

        var filterOption = {
          name: "SalesAreas",
          value: selectedSalesArea
        };
        filterOptions.push(filterOption);
      }

      if (this.filter.ChannelType.length > 0) {
        var selectedTypes = "";
        var count = 0;

        for (var i = 0; i < this.filter.ChannelType.length; i++) {
          selectedTypes += "Type" + this.filter.ChannelType[i];
          if (count !== this.filter.ChannelType.length - 1) {
            selectedTypes += "%";
          }
          count++;
        }

        var filterOption = {
          name: "UserTypes",
          value: selectedTypes
        };

        filterOptions.push(filterOption);
      }

      return JSON.stringify(filterOptions);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/application/CMUserInfo/CMUserInfo.vue